import React, { useState, useEffect, useRef } from "react";
import "./NotificationPopup.css";

const NotificationPopup = () => {
  const [visible, setVisible] = useState(true);
  const timerRef = useRef(null);

  useEffect(() => {
    // Bugünün tarihini al
    const today = new Date();
    // 10 Temmuz 2025 tarihi (ay: 0 tabanlı değil, 6 = Temmuz)
    const cutoffDate = new Date(2025, 6, 10);

    if (today > cutoffDate) {
      // Bugün 10 Temmuz'dan sonraysa görünmez yap
      setVisible(false);
      return;
    }

    // Eğer tarih uygunsa, 10 saniye sonra kaybolma timer'ı
    timerRef.current = setTimeout(() => {
      setVisible(false);
    }, 10000);

    return () => clearTimeout(timerRef.current);
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timerRef.current);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setVisible(false);
    }, 15000);
  };

  if (!visible) return null;

  return (
    <div
      className="notification-popup"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="alert"
      aria-live="polite"
      style={{ userSelect: "none", position: "fixed" }}
    >
      <h4>📢 Yeni Güncellemeler</h4>
      <p>10 Farklı Arayüz Dili ve 10 Farklı Yazım Dili Eklendi!</p>
      <button
        aria-label="Kapat"
        className="close-btn"
        onClick={(e) => {
          e.stopPropagation();
          setVisible(false);
        }}
      >
        ✕
      </button>
    </div>
  );
};

export default NotificationPopup;
